import { z } from 'zod';
import type { ClientDto } from './catalog';
import { idSchema } from './common';
import type { PalletDto } from './pallets';
import type { LocationDto } from './warehouse';

export const inventorySummaryQuerySchema = z.object({ clientId: idSchema.optional() });

export interface InventorySummaryProduct {
  productId: number;
  productName: string;
  pallets: number;
}

/** Resumen por cliente: "Cliente A — Manzana: 20, Pera: 10 — TOTAL 30". */
export interface InventorySummaryClient {
  clientId: number;
  clientName: string;
  total: number;
  products: InventorySummaryProduct[];
}

export interface WarehouseStatsDto {
  locations: {
    total: number;
    /** Utilizables (no fuera de servicio). */
    usable: number;
    outOfService: number;
    occupied: number;
    free: number;
  };
  /** Ocupación sobre ubicaciones utilizables, en %. */
  occupancyPct: number;
  palletsInStock: number;
  pendingLocation: number;
  reservedForExit: number;
  clientsWithStock: number;
}

export const searchQuerySchema = z.object({
  q: z.string().trim().min(1, 'Escriba algo para buscar').max(100),
});

export interface SearchResultDto {
  query: string;
  /** Coincidencia exacta con un código de palet (lectura de pistola). */
  pallet: PalletDto | null;
  /** Coincidencia exacta con un código de ubicación. */
  location: LocationDto | null;
  /** Palets cuya referencia del cliente coincide exactamente (en almacén primero). */
  byReference: PalletDto[];
  /** Palets en almacén que coinciden por texto (código, referencia, cliente o mercancía). */
  pallets: PalletDto[];
  clients: ClientDto[];
}
